import { render, staticRenderFns } from "./ElInputDay.vue?vue&type=template&id=22345c1e"
import script from "./ElInputDay.vue?vue&type=script&lang=js"
export * from "./ElInputDay.vue?vue&type=script&lang=js"
import style0 from "./ElInputDay.vue?vue&type=style&index=0&id=22345c1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports